"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCartNotification = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
function trackCartNotification(notification_message, notification_type) {
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        event: 'JS_Event',
        eventData: {
            eventName: enums_1.GA4EventName.ShowNotification,
            feature_category: enums_1.GA4FeatureCategory.Cart,
            notification_type,
            notification_message,
        },
    });
}
exports.trackCartNotification = trackCartNotification;
//# sourceMappingURL=trackCartNotification.js.map